<template>
  <div class="content">
    <van-nav-bar title="充值记录"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" />

    <van-tabs @click="onClick">
      <van-tab title="支付成功">

        <div v-if="status == 1"
             :key="render">
          <div class="date_content">
            <div class="date_title">起至日期:</div>
            <van-field v-model="start"
                       left-icon="notes-o"
                       @click="selectDate('start')"
                       readonly />
            <div>—</div>
            <van-field v-model="stop"
                       left-icon="notes-o"
                       readonly
                       @click="selectDate('stop')" />
          </div>

          <van-popup v-model="show"
                     position="bottom"
                     :style="{ height: '41%' }">
            <van-datetime-picker v-model="currentDate"
                                 type="date"
                                 :title="dateTitle"
                                 :min-date="minDate"
                                 :max-date="maxDate"
                                 @cancel="cancelPopup()"
                                 @confirm="chooseData($event,dateTitle)"
                                 :formatter="formatter" />
          </van-popup>

          <van-list v-model="loading"
                    :finished="finished"
                    offset="50"
                    @load="onLoad">
            <template #finished
                      v-if="list.length != 0">
              没有更多了
            </template>
            <van-cell size="large"
                      class="cell_item"
                      v-for="item in list"
                      :key="item.time"
                      :title="item.time">
              <template #title>
                <span class="custom-title">{{item.payType == 'SF' ? '水费充值' : '电费充值'}}</span>
              </template>
              <template #default>
                <span class="custom-default">﹢￥{{item.price}}</span>
              </template>
              <template #label>
                <span class="custom-label">{{item.payTime}}</span>
              </template>

            </van-cell>
          </van-list>
          <van-icon :name="require('../assets/notFind.png')"
                    color="#696136"
                    class="not_find"
                    v-if="list.length == 0" />
        </div>

      </van-tab>
      <van-tab title="待支付">
        <div v-if="status == 0"
             :key="render">
          <div class="date_content">
            <div class="date_title">起至日期:</div>
            <van-field v-model="start"
                       left-icon="notes-o"
                       @click="selectDate('start')"
                       readonly />
            <div>—</div>
            <van-field v-model="stop"
                       left-icon="notes-o"
                       readonly
                       @click="selectDate('stop')" />
          </div>

          <van-popup v-model="show"
                     position="bottom"
                     :style="{ height: '41%' }">
            <van-datetime-picker v-model="currentDate"
                                 type="date"
                                 :title="dateTitle"
                                 :min-date="minDate"
                                 :max-date="maxDate"
                                 @cancel="cancelPopup()"
                                 @confirm="chooseData($event,dateTitle)"
                                 :formatter="formatter" />
          </van-popup>

          <van-list v-model="loading"
                    :finished="finished"
                    offset="50"
                    @load="onLoad">
            <template #finished
                      v-if="list.length != 0">
              没有更多了
            </template>
            <van-cell size="large"
                      class="cell_item"
                      v-for="item in list"
                      :key="item.time"
                      :title="item.time">
              <template #title>
                <span class="custom-title">{{item.payType == 'SF' ? '水费充值' : '电费充值'}}</span>
              </template>
              <template #default>
                <span class="custom-default"
                      style="color:#9A9A9A;">￥{{item.price}}</span>
                <van-button size="mini"
                            style="margin-left:10px;"
                            type="primary"
                            @click="checkOrderStatus(item)">查询</van-button>
              </template>
              <template #label>
                <span class="custom-label">{{item.createTime}}</span>
              </template>

            </van-cell>
          </van-list>
          <van-icon :name="require('../assets/notFind.png')"
                    color="#696136"
                    class="not_find"
                    v-if="list.length == 0" />
        </div>

      </van-tab>
    </van-tabs>

    <van-dialog v-model:show="checkShow"
                title="查询结果"
                :show-cancel-button="false"
                @confirm="upDateStatus">
      <img src="../assets/loadingPay.png"
           width="50"
           height="50"
           style="margin-top:10px;"
           v-if="!payStatus" />
      <img src="../assets/successPay.png"
           width="50"
           height="50"
           style="margin-top:10px;"
           v-else />
      <div style="margin:10px 0">{{checkPrice}}</div>
      <div style="margin:10px 0;">{{checkContent}}</div>
      <div style="margin:10px 0">{{checkTime}}</div>
    </van-dialog>

  </div>
</template>

<script>
import moment, { months } from "moment"
import { Dialog } from 'vant';

export default {
  name: 'PayInfo',
  data() {
    return {
      show: false,
      dateTitle: '开始时间',
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      list: [],
      loading: false,
      finished: false,
      page: 1,
      size: 15,
      start: '',
      stop: '',
      roomId: '',
      type: '',
      status: 1,
      checkShow: false,
      checkContent: '',
      checkPrice: '',
      checkTime: '',
      payStatus: 0,
      render: 0
    };
  },
  created() {

  },
  mounted() {
    if (window.sessionStorage.getItem('openInfo') == null || JSON.parse(window.sessionStorage.getItem('openInfo')).roomId == null || window.sessionStorage.getItem('infoType') == null) {
      this.$router.push('/detail')
    }

    this.roomId = JSON.parse(window.sessionStorage.getItem('openInfo')).roomId
    let type = window.sessionStorage.getItem('infoType')

    if (type == 'W') {
      this.type = 'SF'
    } else if (type == 'E') {
      this.type = 'DF'
    }
    this.start = moment().year() + '-' + (moment().month() - 0 + 1) + '-01'
    // this.start = moment().format('YYYY-MM-DD')
    this.stop = moment().format('YYYY-MM-DD')
  },
  methods: {
    onClickLeft() {
      this.$router.push('/pay')
    },
    onLoad() {
      this.$axios.post('/room/getRoomOrder?page=' + this.page + '&roomId=' + this.roomId + '&size=' + this.size + '&start=' + this.start + ' 00:00:00' + '&stop=' + this.stop + ' 23:59:59' + '&type=' + this.type + '&status=' + this.status).then(res => {
        if (res.code == 200) {
          this.list = this.list.concat(res.object.pageInfo.list)
          this.loading = false

          if (res.object.pageInfo.total < this.size * this.page) {
            this.finished = true
          }
          this.page++


        } else {
          this.$toast.fail(res.message)
          this.loading = false
          this.finished = true
        }


      }).catch(err => {
        this.loading = false
        this.finished = true
        console.log(err)
      })
    },
    // 切换查询的订单状态
    onClick(type) {
      this.render++
      this.page = 1
      this.list = []
      this.finished = false
      if (type == 0) {
        this.status = 1
      } else {
        this.status = 0
      }

    },
    upDateStatus() {
      // console.log(type)
      if (this.payStatus == true) {
        this.render++
        this.list = []
        this.page = 1
        this.finished = false
      }

    },
    // 日期选择器打开。
    selectDate(type) {

      this.dateTitle = type == 'start' ? '开始日期' : '结束日期'

      if (type == 'start') {
        let stopDate = new Date(this.stop)
        let nowDate = new Date(moment().year(), moment().month(), moment().format('DD'))
        if (stopDate < nowDate) {
          console.log("stopDate 大于 nowDate");
          this.maxDate = new Date(this.stop)

        } else {
          this.maxDate = new Date(moment().year(), moment().month(), moment().format('DD'))

        }
        this.minDate = new Date(2020, 0, 1)
        // this.maxDate = new Date(moment().year(), moment().month(), moment().format('DD'))
      } else {
        let startArray = this.start.split('-')
        this.minDate = new Date(startArray[0], startArray[1] - 1, startArray[2])
        this.maxDate = new Date(moment().year() + 2, moment().month() + 1, moment().format('D'))
      }
      this.show = true

    },
    cancelPopup() {
      this.show = false
    },
    chooseData(value, type) {
      type == '开始日期' ? this.start = moment(value).format('YYYY-MM-DD')
        : this.stop = moment(value).format('YYYY-MM-DD')
      this.list = []

      this.page = 1
      this.loading = false
      this.show = false

      if (this.finished) {
        this.finished = false

      } else {
        this.onLoad()
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    checkOrderStatus(item) {
      console.log(item)
      this.$axios.post('/wx/preOrderQuery?payId=' + item.payId + '&preorderId=' + item.preOrderId).then(res => {
        this.checkShow = true
        this.checkPrice = "订单价格:" + item.price
        this.checkContent = "订单状态:" + res.message
        this.checkTime = "订单创建时间:" + item.createTime
        if (res.code == 200) {
          this.payStatus = true
        } else {
          this.payStatus = false
        }

      }).catch(err => {
        console.log(err)
      })

    }

  }
};
</script>

<style scoped lang="less">
.date_content {
  display: flex;
  align-items: center;
  background: white;
  justify-content: center;
  padding: 10px 0;
  color: #626262;

  .date_title {
    font-size: 13px;
    margin: 0 5px;
  }

  .van-field {
    width: 120px;
    margin: 0 10px;
    padding: 2px;
    background: #eee;
  }
}

.van-cell__title {
  text-align: start;
}

.van-cell__value {
  font-size: 18px;
  display: flex;
  color: red;
  font-weight: 500;
  justify-content: flex-end;
  align-items: center;
}

.van-icon__image {
  margin-top: 100px;
  height: 300px;
  width: 100%;
}
</style>
